import O1HD from "../../../../../engines/gameEngine";
import normalMode from "../../../normalMode";
import {getRandomHongPrize, HongDefine} from "../config/HongPrizeConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import gameConfig from "../../../../../engines/configs/gameConfig";
import LotteryCenterV2Prefab from "./LotteryCenterV2Prefab";
import {getRandomGoldHongPrize} from "../config/HongGoldPrizeConfig";
import utilsModel from "../../../../../engines/libs/utilsModel";
const {ccclass, property} = cc._decorator;


@ccclass
export default class LotteryGGLV2Prefab extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;
    @property({type:cc.Label,displayName:"价格"})
    lbPrize : cc.Label = null;
    @property({type:cc.Node,displayName:"购买按钮"})
    purchaseBtnNode : cc.Node = null;
    @property({type:cc.Node,displayName:"奖券次数消耗按钮"})
    lotteryCountBtnNode : cc.Node = null;
    @property({type:cc.Node,displayName:"广告购买按钮"})
    adPurchaseBtnNode : cc.Node = null;
    @property({type:cc.Node,displayName:"金色传说"})
    jscsNode : cc.Node = null;
    @property({type:cc.Node,displayName:"金色刮刮乐背景"})
    jsgglLotteryBg : cc.Node = null;

    @property(cc.Label)
    lbLotteryConsume : cc.Label = null;

    mGameLayer : NormalGameManager;
    //金色 判断
    private mGoldFlag : boolean = false;
    private mParentScript : LotteryCenterV2Prefab;

    onLoad () {
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{ easing:cc.easing.backOut }).start();
    }

    start () {

    }

    /**
     * 绑定数据
     * @param parentScript
     */
    bindData( parentScript : LotteryCenterV2Prefab, goldFlag : boolean ){
        this.mParentScript = parentScript;
        this.mGoldFlag = goldFlag;
        this.mGameLayer = NormalGameManager._instance;
        if ( !this.mGameLayer.getGameData().lotteryInfo ) {
            //初始化数据
            this.mGameLayer.getGameData().lotteryInfo = { gglValidCount : 0 , hjGGLValidCount : 0 ,currGGLPurchaseCount : 0 , currGJGGLPurchaseCount:0,currSuperGGLPurchaseCount:0 ,currNewGGLPurchaseCount : 0};
            this.mGameLayer.writeGameData();
        }
        if ( this.mGoldFlag ) {
            this.jsgglLotteryBg.active = true;
            O1HD.emit("activeLotteryGold" );
            this.lbPrize.string = `40`;
        }
        this.refreshBtn();
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            this.mParentScript && this.mParentScript.refreshBtn();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

    /**
     * 获取当前奖项
     */
    getPrize(  ) : HongPrizeEntity{
        let randomPrizeEntity : HongPrizeEntity = this.mGoldFlag ? getRandomGoldHongPrize() as HongPrizeEntity : getRandomHongPrize() as HongPrizeEntity;
        let prizeRate = this.mGoldFlag ? gameConfig.GGL_GOLD_WEIGHT : gameConfig.GGL_NORMAL_WEIGHT ;
        let randomPrizeNum : number = Math.floor( Math.random() * 10000 * prizeRate );
        if ( randomPrizeNum <= randomPrizeEntity.weight ) {
            randomPrizeEntity.flag = true;
        }else{
            randomPrizeEntity.flag = false;
        }
        return  randomPrizeEntity;
    }

    /**
     * 购买
     */
    onBtnPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let needPayPrice : number = this.mGoldFlag ? 40 : 20;
        if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins( -needPayPrice,true );
        this.jscsNode.active = false;
        if ( this.mGoldFlag ) {
            this.mGameLayer.getGameData().lotteryInfo.currGJGGLPurchaseCount ++;
        }else{
            this.mGameLayer.getGameData().lotteryInfo.currGGLPurchaseCount ++;
        }
        this.mGameLayer.writeGameData();
        this.currOpenCount = 0;
        this.refreshBtn();
        //重置红包1
        O1HD.emit("Hong1Node.reset");
        O1HD.emit("Hong2Node.reset");
        O1HD.emit("Hong3Node.reset");
    }

    /**
     * 广告购买
     */
    onBtnAdPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.jscsNode.active = false;
            this.currOpenCount = 0;
            this.refreshBtn();
            //重置红包1
            O1HD.emit("Hong1Node.reset");
            O1HD.emit("Hong2Node.reset");
            O1HD.emit("Hong3Node.reset");
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"彩票解锁");
    }

    private currOpenCount : number = 0;
    openPrize(){
        this.currOpenCount ++;
        if ( this.currOpenCount == 3 ) {
            // this.purchaseBtnNode.active = true;
        }
    }

    /**
     * 触发彩蛋
     * @param dayUnique 唯一天数
     */
    openEgg( dayUnique : number ){
        switch ( dayUnique ) {
            case 2:
                this.jscsNode.active = true;
                //打开金光彩蛋 效果
                O1HD.getManagers().soundMgr.playSound("jscs").then();
                O1HD.emit("openGoldEffect" );
                //第二天的彩蛋
                this.scheduleOnce(()=>{
                    O1HD.emit("Hong1Node.eggOpenPrize");
                },3 );
                this.scheduleOnce(()=>{
                    O1HD.emit("Hong2Node.eggOpenPrize");
                },6 );
                this.scheduleOnce(()=>{
                    O1HD.emit("Hong3Node.eggOpenPrize");
                },9 );

                this.scheduleOnce(()=>{
                    this.purchaseBtnNode.active = true;
                },11 );
                break;
            case 4:
                //第四天的彩蛋
                O1HD.emit("gglEggFour" );
                break;
        }
    }

    /**
     * 彩票购买次数
     */
    onBtnLotteryCount( e ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let lotteryInfo = this.mGameLayer.getGameData().lotteryInfo;
        if ( this.mGoldFlag ) {
            if ( lotteryInfo.hjGGLValidCount <= 0 ){
                O1HD.getModules().uiControlModule.showMessageBox("奖券次数不够");
                this.refreshBtn();
                return;
            }
            lotteryInfo.hjGGLValidCount --;
        }else{
            if ( lotteryInfo.gglValidCount <= 0 ){
                O1HD.getModules().uiControlModule.showMessageBox("奖券次数不够");
                this.refreshBtn();
                return;
            }
            lotteryInfo.gglValidCount --;
        }
        this.mGameLayer.writeGameData();
        this.jscsNode.active = false;
        // this.purchaseBtnNode.active = false;
        this.currOpenCount = 0;
        //重置红包1
        O1HD.emit("Hong1Node.reset");
        O1HD.emit("Hong2Node.reset");
        O1HD.emit("Hong3Node.reset");
        this.refreshBtn();
    }



    /**
     * 刷新按钮
     */
    refreshBtn(  ){
        let lotteryInfo = this.mGameLayer.getGameData().lotteryInfo;
        if ( lotteryInfo  ) {
            if ( this.mGoldFlag && lotteryInfo.hjGGLValidCount > 0 ) {
                //黄金
                this.lbLotteryConsume.string = `X ${lotteryInfo.hjGGLValidCount}`;
                this.lotteryCountBtnNode.active = true;
                this.purchaseBtnNode.active = false;
            }else if( !this.mGoldFlag && lotteryInfo.gglValidCount > 0) {
                //普通
                this.lbLotteryConsume.string = `X ${lotteryInfo.gglValidCount}`;
                this.lotteryCountBtnNode.active = true;
                this.purchaseBtnNode.active = false;
            }else{
                if ( (!this.mGoldFlag && lotteryInfo.currGGLPurchaseCount >= gameConfig.GGL_CURR_LIMIT )
                    || ( this.mGoldFlag && lotteryInfo.currGJGGLPurchaseCount >= gameConfig.HJGGL_CURR_LIMIT) ) {
                    // 显示看视频购买按钮
                    this.adPurchaseBtnNode.active = true;
                }else{
                    this.adPurchaseBtnNode.active = false;
                    this.lotteryCountBtnNode.active = false;
                    this.purchaseBtnNode.active = true;
                }
            }
        }else{
            this.lotteryCountBtnNode.active = false;
            this.purchaseBtnNode.active = true;
        }
    }
}

export interface HongPrizeEntity extends HongDefine{
    flag : boolean;//中奖真假
}

/**
 * 彩蛋定义
 * @constructor
 */
export function EggDefine(){
    const dataDefine : eggEntity[] = [
        {
            pointConcatStr : "",
            prizeArray : [
                {prizeNum:1,}
            ],
        }
    ];
    return dataDefine;
}

//鸡蛋 实体
export interface eggEntity {
    pointConcatStr : string;//点击字符串
    prizeArray : { prizeNum : number , type? : number }[];//开奖数组
}
